{
  "welcome": {
    "title": "Welcome, {{name}}",
    "title_noName": "Welcome to Rhemn",
    "body": "Anything that glows will show you what it does. Explore in any order, whenever you like.",
    "start": "Start exploring",
    "later": "Not now"
  },
  "card": {
    "tryIt": "Try it",
    "takeALook": "Take a look",
    "pro": "Part of Rhemn Pro",
    "close_aria": "Close"
  },
  "pill": {
    "progress": "{{count}} of {{total}} explored",
    "progress_short": "{{count}} of {{total}}",
    "done": "Done",
    "done_aria": "Finish exploring",
    "complete": "All explored"
  },
  "sr": {
    "started": "Explore mode is on. Buttons show what they do before they act.",
    "hint": "Explore mode. Shows what this does first.",
    "ended": "Explore mode is off."
  },
  "settings": {
    "row": "How Rhemn works",
    "row_sub": "A short look at each part",
    "row_aria": "How Rhemn works: explore the app again",
    "helpCaption": "Help"
  },
  "steps": {
    "intention": {
      "title": "Today's intention",
      "body": "Write the one thing that matters most today, and check it off when it's done."
    },
    "now": {
      "title": "Your day, by prayer",
      "body": "Rhemn divides your day at each prayer. This shows the time left before the next one, and what you've planned for it."
    },
    "verse": {
      "title": "Verse insights",
      "body": "Ask a question about today's verse, read a short tafsir, and find verses on the same theme."
    },
    "qibla": {
      "title": "Qibla",
      "body_chrome": "The direction of the Kaaba from where you are, as a bearing from north.",
      "body_ios": "Points toward the Kaaba from where you are. Turn on the live compass and it follows you as you turn."
    },
    "prayer": {
      "title": "Prayer times",
      "body_chrome": "Today's five prayer times for where you are. Choose the calculation method your mosque follows.",
      "body_ios": "Your next prayer at a glance. Open it for all five times and a reminder for each."
    },
    "tasks": {
      "title": "Tasks",
      "body": "Keep your to-dos in lists, and give each one a place between the prayers."
    },
    "notes": {
      "title": "Notes",
      "body_chrome": "Write, or just speak. Rhemn transcribes your voice notes and meetings, then summarizes them.",
      "body_ios": "Write, or just speak. Rhemn turns what you say into clean, summarized notes."
    },
    "profile": {
      "title_chrome": "Your profile",
      "body_chrome": "Your account and privacy settings. Come back here to explore Rhemn again.",
      "title_ios": "More",
      "body_ios": "Saved verses, Qibla, and your account settings. You can explore Rhemn again from here."
    }
  }
}
